<app-side-menu (sideNavMessage$)="listenerNav($event)" [language]="language" [compact]="true"></app-side-menu>
<app-nav-bar (navMessage$)="listenerNav($event)"></app-nav-bar>

<div class="content-page">
    <div class="content p-1 crumbs">
        <div class="content text-dark">
            <div class="d-flex align-items-center">
                <nav style="--bs-breadcrumb-divider: '>';" aria-label="breadcrumb">
                    <ol class="breadcrumb text-capitalize text-dark h5">
                        <li class="breadcrumb-item"><a [routerLink]="['/reports']" class="text-secondary">Reports</a></li>
                        <li class="breadcrumb-item text-secondary" aria-current="page">Past Due Analysis Report</li>
                    </ol>
                </nav>
            </div>
        </div>
    </div>
    
    @if (security.permitted('reports', 'past due analysis', 'view')) {
        <aside>            
            <form [formGroup]="form">
                <div class="form-group">
                    <select class="form-control" name="lot" id="lot-filter" formControlName="lotId">
                        <option value="0">All Lots</option>
                        @for (lot of lots; track lot.id) {
                            <option value="{{lot.id}}">{{lot.contact.name}}</option>
                        }
                    </select>
                </div>
                <div class="form-group">
                    <select class="form-control" name="group" id="group-filter" formControlName="group">
                        <option value="method">by Collection Method</option>
                        <option value="days">by Days Past Due</option>
                    </select>
                </div>
            </form>
        </aside>

        <main>
            @if (summary && (summary.companyId)) {
                <h3>{{summary.company}}</h3>
                <h5>Past Due Analysis of In-House Financing Receivables as of {{summary.asOf | date:'E MMM d, yyyy'}}</h5>

                <ul class="list-group list-group-horizontal justify-content-center flexed">
                    <li class="list-group-item"><span class="text-primary">Accounts</span> <span>{{summary.count | number: '1.0-0'}}</span></li>
                    <li class="list-group-item"><span class="text-muted">Current</span> <span>{{summary.current | number: '1.0-0'}}</span></li>
                    @if (summary.count > 0) {
                        <li class="list-group-item"><span class="text-muted">Percent Current</span> <span>{{(summary.current / summary.count) | percent}}</span></li>
                    }
                </ul>

                <ul class="list-group justify-content-center flexed">
                    <li class="list-group-item"><span class="text-primary">Payment Balance (1+2+3+4+5)</span> <span>{{summary.paymentBalance | currency}}</span></li>
                    <li class="list-group-item"><span class="text-primary">Principal + Tax (1+2)</span> <span>{{(summary.balance + summary.taxBalance) | currency}}</span></li>
                    <li class="list-group-item"><span class="text-primary">Payoff Balance (1+2+4+5)</span> <span>{{summary.payoff | currency}}</span></li>
                    <li class="list-group-item"><span class="text-primary">Riding Cash</span> <span [class.text-danger]="summary.ridingCash > 0" [class.text-success]="summary.ridingCash < 0">{{summary.ridingCash | currency}}</span></li>
                </ul>

                <ul class="list-group justify-content-center flexed">
                    <li class="list-group-item"><span class="text-primary">1. Principal Balance</span> <span>{{summary.balance | currency}}</span></li>
                    <li class="list-group-item"><span class="text-primary">2. Financed Sales Tax Balance</span> <span>{{(summary.taxBalance) | currency}}</span></li>
                    <li class="list-group-item"><span class="text-primary">3. Unearned Future Finance Charges</span> <span>{{summary.unearnedInterest | currency}}</span></li>
                    <li class="list-group-item"><span class="text-primary">4. Unpaid Finance Charges Past Due</span> <span>{{summary.unpaidEarnedInterest | currency}}</span></li>
                    <li class="list-group-item"><span class="text-primary">5. Unpaid Late Fees Due</span> <span>{{summary.lateFees | currency}}</span></li>
                </ul>

                <h6 class="text-danger">NOTE: Principal Balances DO NOT include Financed Sales Tax Balanaces but DO include Sales Tax on initial down payments.</h6>

                <ul class="list-group list-group-horizontal justify-content-center flexed">
                    <li class="list-group-item"><span class="text-primary">Total Amount Late</span> <span>{{summary.lateAmt | currency}}</span></li>
                    @if (summary.paymentBalance > 0) {
                        <li class="list-group-item"><span class="text-primary">Percent of Pament Balance</span> <span>{{(summary.lateAmt / summary.paymentBalance) | percent}}</span></li>
                    }
                </ul>

                <table class="table table-sm analysis">
                    <tbody>
                        <tr>
                            <td>1-15 Days Late</td>
                            <td>{{summary.late1To15 || 0 | number: '1.0-0'}}</td>

                            <td>Amount Due</td>
                            <td>{{summary.late1To15Amt || 0 | currency}}</td>

                            <td>% of Total Amount Late</td>
                            <td>
                                @if (summary.lateAmt > 0) {
                                    {{((summary.late1To15Amt || 0) / summary.lateAmt) | percent}}
                                }
                                @else {
                                    {{0 | currency}}
                                }
                            </td>

                            <td>% of Total Payment Balance</td>
                            <td>
                                @if (summary.paymentBalance > 0) {
                                    {{((summary.late1To15Amt || 0) / summary.paymentBalance) | percent}}
                                }
                                @else {
                                    {{0 | currency}}
                                }
                            </td>
                        </tr>
                        <tr>
                            <td>16-30 Days Late</td>
                            <td>{{summary.late16To30 || 0 | number: '1.0-0'}}</td>

                            <td>Amount Due</td>
                            <td>{{summary.late16To30Amt || 0 | currency}}</td>

                            <td>% of Total Amount Late</td>
                            <td>
                                @if (summary.lateAmt > 0) {
                                    {{((summary.late16To30Amt || 0) / summary.lateAmt) | percent}}
                                }
                                @else {
                                    {{0 | currency}}
                                }
                            </td>

                            <td>% of Total Payment Balance</td>
                            <td>
                                @if (summary.paymentBalance > 0) {
                                    {{((summary.late16To30Amt || 0) / summary.paymentBalance) | percent}}
                                }
                                @else {
                                    {{0 | currency}}
                                }
                            </td>
                        </tr>
                        <tr>
                            <td>31-60 Days Late</td>
                            <td>{{summary.late31To60 || 0 | number: '1.0-0'}}</td>

                            <td>Amount Due</td>
                            <td>{{summary.late31To60Amt || 0 | currency}}</td>

                            <td>% of Total Amount Late</td>
                            <td>
                                @if (summary.lateAmt > 0) {
                                    {{((summary.late31To60Amt || 0) / summary.lateAmt) | percent}}
                                }
                                @else {
                                    {{0 | currency}}
                                }
                            </td>

                            <td>% of Total Payment Balance</td>
                            <td>
                                @if (summary.paymentBalance > 0) {
                                    {{((summary.late31To60Amt || 0) / summary.paymentBalance) | percent}}
                                }
                                @else {
                                    {{0 | currency}}
                                }
                            </td>
                        </tr>
                        <tr>
                            <td>61-90 Days Late</td>
                            <td>{{summary.late61To90 || 0 | number: '1.0-0'}}</td>

                            <td>Amount Due</td>
                            <td>{{summary.late61To90Amt || 0 | currency}}</td>

                            <td>% of Total Amount Late</td>
                            <td>
                                @if (summary.lateAmt > 0) {
                                    {{((summary.late61To90Amt || 0) / summary.lateAmt) | percent}}
                                }
                                @else {
                                    {{0 | currency}}
                                }
                            </td>

                            <td>% of Total Payment Balance</td>
                            <td>
                                @if (summary.paymentBalance > 0) {
                                    {{((summary.late61To90Amt || 0) / summary.paymentBalance) | percent}}
                                }
                                @else {
                                    {{0 | currency}}
                                }
                            </td>
                        </tr>
                        <tr>
                            <td>&gt; 91 Days Late</td>
                            <td>{{summary.late91AndOver || 0 | number: '1.0-0'}}</td>

                            <td>Amount Due</td>
                            <td>{{summary.late91AndOverAmt || 0 | currency}}</td>

                            <td>% of Total Amount Late</td>
                            <td>
                                @if (summary.lateAmt > 0) {
                                    {{((summary.late91AndOverAmt || 0) / summary.lateAmt) | percent}}
                                }
                                @else {
                                    {{0 | currency}}
                                }
                            </td>

                            <td>% of Total Payment Balance</td>
                            <td>
                                @if (summary.paymentBalance > 0) {
                                    {{((summary.late91AndOverAmt || 0) / summary.paymentBalance) | percent}}
                                }
                                @else {
                                    {{0 | currency}}
                                }
                            </td>
                        </tr>
                    </tbody>
                </table>

                <ul class="list-group list-group-horizontal justify-content-center flexed">
                    <li class="list-group-item"><span class="text-primary">Total Number of Accounts Late</span> <span>{{summary.late | number: '1.0-0'}}</span></li>
                    @if (summary.count > 0) {
                        <li class="list-group-item"><span class="text-primary">Percent of Total Number</span> <span>{{(summary.late / summary.count) | percent}}</span></li>
                    }
                </ul>

                <table class="table table-sm analysis">
                    <tbody>
                        <tr>
                            <td>1-15 Days Late</td>
                            <td>{{summary.late1To15 || 0 | number: '1.0-0'}}</td>

                            <td>% of Number Accounts Late</td>
                            <td>
                                @if (summary.late > 0) {
                                    {{((summary.late1To15 || 0) / summary.late) | percent}}
                                }
                                @else {
                                    {{0 | currency}}
                                }
                            </td>

                            <td>% of Total Number</td>
                            <td>
                                @if (summary.count > 0) {
                                    {{((summary.late1To15 || 0) / summary.count) | percent}}
                                }
                                @else {
                                    {{0 | currency}}
                                }
                            </td>
                        </tr>
                        <tr>
                            <td>16-30 Days Late</td>
                            <td>{{summary.late16To30 || 0 | number: '1.0-0'}}</td>

                            <td>% of Number Accounts Late</td>
                            <td>
                                @if (summary.late > 0) {
                                    {{((summary.late16To30 || 0) / summary.late) | percent}}
                                }
                                @else {
                                    {{0 | currency}}
                                }
                            </td>

                            <td>% of Total Number</td>
                            <td>
                                @if (summary.count > 0) {
                                    {{((summary.late16To30 || 0) / summary.count) | percent}}
                                }
                                @else {
                                    {{0 | currency}}
                                }
                            </td>
                        </tr>
                        <tr>
                            <td>31-60 Days Late</td>
                            <td>{{summary.late31To60 || 0 | number: '1.0-0'}}</td>

                            <td>% of Number Accounts Late</td>
                            <td>
                                @if (summary.lateAmt > 0) {
                                    {{((summary.late31To60 || 0) / summary.lateAmt) | percent}}
                                }
                                @else {
                                    {{0 | currency}}
                                }
                            </td>

                            <td>% of Total Number</td>
                            <td>
                                @if (summary.count > 0) {
                                    {{((summary.late31To60 || 0) / summary.count) | percent}}
                                }
                                @else {
                                    {{0 | currency}}
                                }
                            </td>
                        </tr>
                        <tr>
                            <td>61-90 Days Late</td>
                            <td>{{summary.late61To90 || 0 | number: '1.0-0'}}</td>

                            <td>% of Number Accounts Late</td>
                            <td>
                                @if (summary.lateAmt > 0) {
                                    {{((summary.late61To90 || 0) / summary.lateAmt) | percent}}
                                }
                                @else {
                                    {{0 | currency}}
                                }
                            </td>

                            <td>% of Total Number</td>
                            <td>
                                @if (summary.count > 0) {
                                    {{((summary.late61To90 || 0) / summary.count) | percent}}
                                }
                                @else {
                                    {{0 | currency}}
                                }
                            </td>
                        </tr>
                        <tr>
                            <td>&gt; 91 Days Late</td>
                            <td>{{summary.late91AndOver || 0 | number: '1.0-0'}}</td>

                            <td>% of Number Accounts Late</td>
                            <td>
                                @if (summary.lateAmt > 0) {
                                    {{((summary.late91AndOver || 0) / summary.lateAmt) | percent}}
                                }
                                @else {
                                    {{0 | currency}}
                                }
                            </td>

                            <td>% of Total Number</td>
                            <td>
                                @if (summary.count > 0) {
                                    {{((summary.late91AndOver || 0) / summary.count) | percent}}
                                }
                                @else {
                                    {{0 | currency}}
                                }
                            </td>
                    </tbody>
                </table>

                @for (item of grouped | keyvalue; track item.key) {
                    @if (lotId <= 0) {
                        <hr />

                        <h3>{{item.value.name}}</h3>
                        <h5>Receivbables as of {{item.value['summary'].asOf | date:'E MMM d, yyyy'}}</h5>

                        <ul class="list-group justify-content-center flexed">
                            <li class="list-group-item"><span class="text-primary">Payment Balance</span> <span>{{item.value['summary'].paymentBalance | currency}}</span></li>
                            <li class="list-group-item"><span class="text-primary">Payoff Balance</span> <span>{{item.value['summary'].payoff | currency}}</span></li>
                        </ul>

                        <ul class="list-group list-group-horizontal justify-content-center flexed">
                            <li class="list-group-item"><span class="text-primary">Accounts</span> <span>{{item.value['count'] | number: '1.0-0'}}</span></li>
                            <li class="list-group-item"><span class="text-muted">Current</span> <span>{{item.value['summary'].current | number: '1.0-0'}}</span></li>
                            @if (item.value['count'] > 0) {
                                <li class="list-group-item"><span class="text-muted">Percent Current</span> <span>{{(item.value['summary'].current / item.value['count']) | percent}}</span></li>
                            }
                        </ul>

                        <section class="row">
                            <ul class="col list-group flexed">
                                <li class="list-group-item"><span class="text-primary">Payment Balance (1+2+3+4+5)</span> <span>{{item.value['summary'].paymentBalance | currency}}</span></li>
                                <li class="list-group-item"><span class="text-primary">Principal + Tax (1+2)</span> <span>{{(item.value['summary'].balance + item.value['summary'].taxBalance) | currency}}</span></li>
                                <li class="list-group-item"><span class="text-primary">Payoff Balance (1+2+4+5)</span> <span>{{item.value['summary'].payoff | currency}}</span></li>
                                <li class="list-group-item"><span class="text-primary">Riding Cash</span> <span [class.text-danger]="item.value['summary'].ridingCash > 0" [class.text-success]="item.value['summary'].ridingCash < 0">{{item.value['summary'].ridingCash | currency}}</span></li>
                            </ul>

                            <ul class="col list-group flexed">
                                <li class="list-group-item"><span class="text-primary">1. Principal Balance</span> <span>{{item.value['summary'].balance | currency}}</span></li>
                                <li class="list-group-item"><span class="text-primary">2. Financed Sales Tax Balance</span> <span>{{(item.value['summary'].taxBalance) | currency}}</span></li>
                                <li class="list-group-item"><span class="text-primary">3. Unearned Future Finance Charges</span> <span>{{item.value['summary'].unearnedInterest | currency}}</span></li>
                                <li class="list-group-item"><span class="text-primary">4. Unpaid Finance Charges Past Due</span> <span>{{item.value['summary'].unpaidEarnedInterest | currency}}</span></li>
                                <li class="list-group-item"><span class="text-primary">5. Unpaid Late Fees Due</span> <span>{{item.value['summary'].lateFees | currency}}</span></li>
                            </ul>
                        </section>

                        <ul class="list-group list-group-horizontal justify-content-center flexed">
                            <li class="list-group-item"><span class="text-primary">Total Amount Late</span> <span>{{item.value['summary'].lateAmt | currency}}</span></li>
                            @if (item.value['summary'].paymentBalance > 0) {
                                <li class="list-group-item"><span class="text-primary">Percent of Pament Balance</span> <span>{{(item.value['summary'].lateAmt / item.value['summary'].paymentBalance) | percent}}</span></li>
                            }
                        </ul>

                        <table class="table table-sm analysis">
                            <tbody>
                                <tr>
                                    <td>1-15 Days Late</td>
                                    <td>{{item.value['summary'].late1To15 || 0 | number: '1.0-0'}}</td>

                                    <td>Amount Due</td>
                                    <td>{{item.value['summary'].late1To15Amt || 0 | currency}}</td>

                                    <td>% of Total Amount Late</td>
                                    <td>
                                        @if (item.value['summary'].lateAmt > 0) {
                                            {{((item.value['summary'].late1To15Amt || 0) / item.value['summary'].lateAmt) | percent}}
                                        }
                                        @else {
                                            {{0 | currency}}
                                        }
                                    </td>

                                    <td>% of Total Payment Balance</td>
                                    <td>
                                        @if (item.value['summary'].paymentBalance > 0) {
                                            {{((item.value['summary'].late1To15Amt || 0) / item.value['summary'].paymentBalance) | percent}}
                                        }
                                        @else {
                                            {{0 | currency}}
                                        }
                                    </td>
                                </tr>
                                <tr>
                                    <td>16-30 Days Late</td>
                                    <td>{{item.value['summary'].late16To30 || 0 | number: '1.0-0'}}</td>

                                    <td>Amount Due</td>
                                    <td>{{item.value['summary'].late16To30Amt || 0 | currency}}</td>

                                    <td>% of Total Amount Late</td>
                                    <td>
                                        @if (item.value['summary'].lateAmt > 0) {
                                            {{((item.value['summary'].late16To30Amt || 0) / item.value['summary'].lateAmt) | percent}}
                                        }
                                        @else {
                                            {{0 | currency}}
                                        }
                                    </td>

                                    <td>% of Total Payment Balance</td>
                                    <td>
                                        @if (item.value['summary'].paymentBalance > 0) {
                                            {{((item.value['summary'].late16To30Amt || 0) / item.value['summary'].paymentBalance) | percent}}
                                        }
                                        @else {
                                            {{0 | currency}}
                                        }
                                    </td>
                                </tr>
                                <tr>
                                    <td>31-60 Days Late</td>
                                    <td>{{item.value['summary'].late31To60 || 0 | number: '1.0-0'}}</td>

                                    <td>Amount Due</td>
                                    <td>{{item.value['summary'].late31To60Amt || 0 | currency}}</td>

                                    <td>% of Total Amount Late</td>
                                    <td>
                                        @if (item.value['summary'].lateAmt > 0) {
                                            {{((item.value['summary'].late31To60Amt || 0) / item.value['summary'].lateAmt) | percent}}
                                        }
                                        @else {
                                            {{0 | currency}}
                                        }
                                    </td>

                                    <td>% of Total Payment Balance</td>
                                    <td>
                                        @if (item.value['summary'].paymentBalance > 0) {
                                            {{((item.value['summary'].late31To60Amt || 0) / item.value['summary'].paymentBalance) | percent}}
                                        }
                                        @else {
                                            {{0 | currency}}
                                        }
                                    </td>
                                </tr>
                                <tr>
                                    <td>61-90 Days Late</td>
                                    <td>{{item.value['summary'].late61To90 || 0 | number: '1.0-0'}}</td>

                                    <td>Amount Due</td>
                                    <td>{{item.value['summary'].late61To90Amt || 0 | currency}}</td>

                                    <td>% of Total Amount Late</td>
                                    <td>
                                        @if (item.value['summary'].lateAmt > 0) {
                                            {{((item.value['summary'].late61To90Amt || 0) / item.value['summary'].lateAmt) | percent}}
                                        }
                                        @else {
                                            {{0 | currency}}
                                        }
                                    </td>

                                    <td>% of Total Payment Balance</td>
                                    <td>
                                        @if (item.value['summary'].paymentBalance > 0) {
                                            {{((item.value['summary'].late61To90Amt || 0) / item.value['summary'].paymentBalance) | percent}}
                                        }
                                        @else {
                                            {{0 | currency}}
                                        }
                                    </td>
                                </tr>
                                <tr>
                                    <td>&gt; 91 Days Late</td>
                                    <td>{{item.value['summary'].late91AndOver || 0 | number: '1.0-0'}}</td>

                                    <td>Amount Due</td>
                                    <td>{{item.value['summary'].late91AndOverAmt || 0 | currency}}</td>

                                    <td>% of Total Amount Late</td>
                                    <td>
                                        @if (item.value['summary'].lateAmt > 0) {
                                            {{((item.value['summary'].late91AndOverAmt || 0) / item.value['summary'].lateAmt) | percent}}
                                        }
                                        @else {
                                            {{0 | currency}}
                                        }
                                    </td>

                                    <td>% of Total Payment Balance</td>
                                    <td>
                                        @if (item.value['summary'].paymentBalance > 0) {
                                            {{((item.value['summary'].late91AndOverAmt || 0) / item.value['summary'].paymentBalance) | percent}}
                                        }
                                        @else {
                                            {{0 | currency}}
                                        }
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <ul class="list-group list-group-horizontal justify-content-center flexed">
                            <li class="list-group-item"><span class="text-primary">Total Number of Accounts Late</span> <span>{{summary.late | number: '1.0-0'}}</span></li>
                            @if (item.value['summary'].count > 0) {
                                <li class="list-group-item"><span class="text-primary">Percent of Total Number</span> <span>{{(summary.late / item.value['summary'].count) | percent}}</span></li>
                            }
                        </ul>

                        <table class="table table-sm analysis">
                            <tbody>
                                <tr>
                                    <td>1-15 Days Late</td>
                                    <td>{{item.value['summary'].late1To15 || 0 | number: '1.0-0'}}</td>

                                    <td>% of Number Accounts Late</td>
                                    <td>
                                        @if (item.value['summary'].late > 0) {
                                            {{((item.value['summary'].late1To15 || 0) / item.value['summary'].late) | percent}}
                                        }
                                        @else {
                                            {{0 | currency}}
                                        }
                                    </td>

                                    <td>% of Total Number</td>
                                    <td>
                                        @if (item.value['summary'].count > 0) {
                                            {{((item.value['summary'].late1To15 || 0) / item.value['summary'].count) | percent}}
                                        }
                                        @else {
                                            {{0 | currency}}
                                        }
                                    </td>
                                </tr>
                                <tr>
                                    <td>16-30 Days Late</td>
                                    <td>{{item.value['summary'].late16To30 || 0 | number: '1.0-0'}}</td>

                                    <td>% of Number Accounts Late</td>
                                    <td>
                                        @if (item.value['summary'].late > 0) {
                                            {{((item.value['summary'].late16To30 || 0) / item.value['summary'].late) | percent}}
                                        }
                                        @else {
                                            {{0 | currency}}
                                        }
                                    </td>

                                    <td>% of Total Number</td>
                                    <td>
                                        @if (item.value['summary'].count > 0) {
                                            {{((item.value['summary'].late16To30 || 0) / item.value['summary'].count) | percent}}
                                        }
                                        @else {
                                            {{0 | currency}}
                                        }
                                    </td>
                                </tr>
                                <tr>
                                    <td>31-60 Days Late</td>
                                    <td>{{item.value['summary'].late31To60 || 0 | number: '1.0-0'}}</td>

                                    <td>% of Number Accounts Late</td>
                                    <td>
                                        @if (item.value['summary'].late > 0) {
                                            {{((item.value['summary'].late31To60 || 0) / item.value['summary'].late) | percent}}
                                        }
                                        @else {
                                            {{0 | currency}}
                                        }
                                    </td>

                                    <td>% of Total Number</td>
                                    <td>
                                        @if (item.value['summary'].count > 0) {
                                            {{((item.value['summary'].late31To60 || 0) / item.value['summary'].count) | percent}}
                                        }
                                        @else {
                                            {{0 | currency}}
                                        }
                                    </td>
                                </tr>
                                <tr>
                                    <td>61-90 Days Late</td>
                                    <td>{{item.value['summary'].late61To90 || 0 | number: '1.0-0'}}</td>

                                    <td>% of Number Accounts Late</td>
                                    <td>
                                        @if (item.value['summary'].late > 0) {
                                            {{((item.value['summary'].late61To90 || 0) / item.value['summary'].late) | percent}}
                                        }
                                        @else {
                                            {{0 | currency}}
                                        }
                                    </td>

                                    <td>% of Total Number</td>
                                    <td>
                                        @if (item.value['summary'].count > 0) {
                                            {{((item.value['summary'].late61To90 || 0) / item.value['summary'].count) | percent}}
                                        }
                                        @else {
                                            {{0 | currency}}
                                        }
                                    </td>
                                </tr>
                                <tr>
                                    <td>&gt; 91 Days Late</td>
                                    <td>{{item.value['summary'].late91AndOver || 0 | number: '1.0-0'}}</td>

                                    <td>% of Number Accounts Late</td>
                                    <td>
                                        @if (item.value['summary'].late > 0) {
                                            {{((item.value['summary'].late91AndOver || 0) / item.value['summary'].late) | percent}}
                                        }
                                        @else {
                                            {{0 | currency}}
                                        }
                                    </td>

                                    <td>% of Total Number</td>
                                    <td>
                                        @if (item.value['summary'].count > 0) {
                                            {{((item.value['summary'].late91AndOver || 0) / item.value['summary'].count) | percent}}
                                        }
                                        @else {
                                            {{0 | currency}}
                                        }
                                    </td>
                            </tbody>
                        </table>
                    }

                    @for (group of item.value[form.get('group').value] | keyvalue; track group.key) {
                        @if (group.value['count'] > 0) {
                            <hr />

                            <h5>{{item.value.name}} has {{group.value['count'] | number: '1.0-0'}} {{group.value['display']}} Accounts</h5>

                            <section class="row">
                                <ul class="col list-group flexed">
                                    <li class="list-group-item"><span class="text-primary">Payment Balance (1+2+3+4+5)</span> <span>{{group.value['summary'].paymentBalance | currency}}</span></li>
                                    <li class="list-group-item"><span class="text-primary">Principal + Tax (1+2)</span> <span>{{(group.value['summary'].balance + group.value['summary'].taxBalance) | currency}}</span></li>
                                    <li class="list-group-item"><span class="text-primary">Payoff Balance (1+2+4+5)</span> <span>{{group.value['summary'].payoff | currency}}</span></li>
                                    <li class="list-group-item"><span class="text-primary">Riding Cash</span> <span [class.text-danger]="group.value['summary'].ridingCash > 0" [class.text-success]="group.value['summary'].ridingCash < 0">{{group.value['summary'].ridingCash | currency}}</span></li>
                                </ul>

                                <ul class="col list-group flexed">
                                    <li class="list-group-item"><span class="text-primary">1. Principal Balance</span> <span>{{group.value['summary'].balance | currency}}</span></li>
                                    <li class="list-group-item"><span class="text-primary">2. Financed Sales Tax Balance</span> <span>{{(group.value['summary'].taxBalance) | currency}}</span></li>
                                    <li class="list-group-item"><span class="text-primary">3. Unearned Future Finance Charges</span> <span>{{group.value['summary'].unearnedInterest | currency}}</span></li>
                                    <li class="list-group-item"><span class="text-primary">4. Unpaid Finance Charges Past Due</span> <span>{{group.value['summary'].unpaidEarnedInterest | currency}}</span></li>
                                    <li class="list-group-item"><span class="text-primary">5. Unpaid Late Fees Due</span> <span>{{group.value['summary'].lateFees | currency}}</span></li>
                                </ul>
                            </section>

                            <table class="table table-sm table-striped clickable">
                                <thead>
                                    <tr>
                                        <th scope="col">Account</th>
                                        <th scope="col">Stock</th>
                                        <th scope="col" class="text-right">Riding Cash</th>
                                        <th scope="col" class="text-right">Principal Balance <abbr title="with Down Payment Tax">DPT</abbr></th>
                                        <th scope="col" class="text-right">Tax Balance</th>
                                        <th scope="col" class="text-right">Unearned Interest</th>
                                        <th scope="col" class="text-right">Unpaid Interest</th>
                                        <th scope="col" class="text-right">Late Fees</th>
                                        <th scope="col" class="text-right">Payoff</th>
                                        <th scope="col" class="text-right">Payment Balance</th>
                                        <th scope="col" class="text-right"># Days Late</th>
                                        <th scope="col" class="text-right">% Principal Paid</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    @for (receivable of group.value['receivables']; track receivable.id) {
                                        <tr [routerLink]="['/accounts']" [queryParams]="{type: receivable.typeId, q: receivable.stock}">
                                            <td>{{receivable.contact}}</td>
                                            <td>{{receivable.stock}}</td>
                                            <td class="text-right" [class.text-danger]="receivable.ridingCash > 0" [class.text-success]="receivable.ridingCash < 0">{{receivable.ridingCash | currency}}</td>
                                            <td class="text-right">{{receivable.balance | currency}}</td>
                                            <td class="text-right">{{receivable.taxBalance | currency}}</td>
                                            <td class="text-right">{{receivable.unearnedInterest | currency}}</td>
                                            <td class="text-right">{{receivable.unpaidEarnedInterest | currency}}</td>
                                            <td class="text-right">{{receivable.lateFees | currency}}</td>
                                            <td class="text-right">{{receivable.payoff | currency}}</td>
                                            <td class="text-right">{{receivable.paymentBalance | currency}}</td>
                                            <td class="text-right">{{daysAgo(receivable.pastDueDate || receivable.due) | number: '1.0-0'}}</td>
                                            <td class="text-right">{{(receivable.percentPrincipalPaid) | number: '1.2-2'}}%</td>
                                        </tr>
                                    }
                                </tbody>
                            </table>
                        }
                    }
                }
            }
        </main>
    }
</div>
